<ng-container [ngSwitch]="renderType">
  <evrideo-ag-grid-evrideo-progress-wheel
    *ngSwitchCase="'progress'"
    [progress]="params.progress"
  >
  </evrideo-ag-grid-evrideo-progress-wheel>
  <evrideo-ag-grid-evrideo-spinning-wheel
    *ngSwitchCase="'spinning'"
    [progress]="params.progress"
    [tooltipText]="params.status"
  >
  </evrideo-ag-grid-evrideo-spinning-wheel>
  <evrideo-ag-grid-evrideo-checked-icon-cell
    *ngSwitchCase="'checked'"
    [checked]="true"
    [loaded]="true"
  >
  </evrideo-ag-grid-evrideo-checked-icon-cell>
  <evrideo-ag-grid-evrideo-checked-icon-cell
    *ngSwitchDefault
    [checked]="false"
    [loaded]="true"
  >
  </evrideo-ag-grid-evrideo-checked-icon-cell>
</ng-container>
